import styled from 'styled-components';
import { StyledLandingContainer } from 'shared/ui/styled-components';

export const StyledSectionWrapper = styled(StyledLandingContainer)`
    max-width: 444px;
`;

export const StyledSectionContainer = styled.div`
    gap: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

export const StyledSectionDescription = styled.div`
    text-align: left;
`;

export const StyledButtonContainer = styled.div`
    display: flex;
    gap: 16px;
    justify-content: flex-start;
    margin-top: 16px;
`;

export const StyledSubstrateContainer = styled(StyledLandingContainer)`
    height: 388px;
    display: flex;
    align-items: center;
    isolation: isolate;
    overflow: hidden;
    position: relative;
`;

export const StyledImage = styled.div`
    height: 456px;
    width: 670px;
    position: absolute;
    top: -28px;
    left: 50%;
    background: url(/plugins/landing/web/images/group-2.webp) no-repeat center/cover;

    @media (max-width: 1160px) {
        left: 560px;
    }

    @media (max-width: 1024px) {
        left: 510px;
    }
`;

export const StyledBackground = styled.div`
    position: absolute;
    width: 100%;
    height: 388px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(90deg, rgb(236, 255, 252) 37.92%, rgb(10, 128, 110) 100%);
    overflow: hidden;
`;
